import { render, staticRenderFns } from "./AdditionalTags.vue?vue&type=template&id=8a914be8"
import script from "./AdditionalTags.vue?vue&type=script&lang=js"
export * from "./AdditionalTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports